import { css } from '@styled-system/css';
import type { FC } from 'react';

import { Logo } from '@/shared/components/ui/Logo';

interface MobileHeaderProps {
  onMenuClick?: () => void;
  onLogoClick?: () => void;
}

export const MobileHeader: FC<MobileHeaderProps> = ({ onMenuClick, onLogoClick }) => {
  const containerStyles = css({
    position: 'relative',
    width: '100%',
    height: '48px',
    backgroundColor: 'rgba(22, 23, 27, 0.9)',
    border: '0.75px solid',
    borderColor: 'border.default',
    borderRadius: 'xl',
    overflow: 'hidden',
  });

  const logoButtonStyles = css({
    position: 'absolute',
    left: '18px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s',
    _hover: {
      opacity: 0.7,
    },
  });

  const menuButtonStyles = css({
    position: 'absolute',
    right: '18px',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '22px',
    height: '22px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s',
    _hover: {
      opacity: 0.7,
    },
  });

  const iconStyles = css({
    width: '100%',
    height: '100%',
    color: 'font.primary',
  });

  return (
    <header className={containerStyles}>
      <button className={logoButtonStyles} onClick={onLogoClick} aria-label="Logo" type="button">
        <Logo variant="cube" className={css({ width: '22px', height: '22px' })} color="font.primary" />
      </button>

      <button className={menuButtonStyles} onClick={onMenuClick} aria-label="Menu" type="button">
        <svg className={iconStyles} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 6H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M3 11H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M3 16H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>
    </header>
  );
};
